var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnsweredQuesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13 7.71445C12.52 10.1168 10.7105 12.3789 8.17148 12.8843C6.93314 13.1312 5.64856 12.9807 4.50065 12.4542C3.35274 11.9277 2.40002 11.0521 1.77814 9.95209C1.15626 8.85206 0.896932 7.58366 1.03708 6.3275C1.17722 5.07134 1.70969 3.89146 2.55868 2.95586C4.30002 1.03589 7.24033 0.507373 9.64019 1.46832",
    stroke: "#00864D",
    strokeWidth: 1.17195,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4 7.11538L6.64706 10L13 2.5",
    stroke: "#00864D",
    strokeWidth: 1.17195,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnsweredQuesIcon);
export default __webpack_public_path__ + "static/media/answered-ques-icon.55f51e51c36b9ce935c14e0749d6132b.svg";
export { ForwardRef as ReactComponent };